export default __webpack_public_path__ + "static/media/personal.a5d67e46.png";